import * as actions from './actions';
import * as getters from './getters';
import * as payoutActions from '../SettingsPayouts/store/actions';
import { state, mutations } from './mutations';
import { state as payoutState, mutations as payoutMutations } from '../SettingsPayouts/store/mutations';

export default {
  actions: { ...actions, ...payoutActions },
  getters,
  state: { ...state, ...payoutState },
  mutations: { ...mutations, ...payoutMutations },
};